import { aiCycleRequest } from "Components/MainBody/api";
import { useQuery } from "@tanstack/react-query";

export const usePollingStatus = (id: string | null) => {
  const {
    data: dataPolling,
    isFetching: isFetchingPolling,
    isError,
    error,
  } = useQuery({
    queryKey: ["check-status", id],

    queryFn: async () => {
      const res = await aiCycleRequest.get(`/valuation/fallback/status/${id}`);
      return { status: res.status, data: res.data };
    },

    refetchInterval: (query) => {
      if (
        query.state.error ||
        query.state.data?.status === 200 ||
        query.state.data?.data?.meta?.status === "FAILED"
      ) {
        return false;
      }
      return 5000;
    },
    enabled: id !== null,
    refetchOnWindowFocus: false,
    retry: false,
  });

  return { dataPolling, isFetchingPolling, isError, error };
};
